import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import DeniedPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { getStore } from '../../../../common/redux/store-utils';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createDeniedScreen = () => {
  const domId = 'deniedPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <DeniedPanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createDeniedScreen = createDeniedScreen;
